import * as PIXI from "pixi.js";
import LayerGroup from "./LayerGroup";

export default class BaseLayer extends PIXI.Container {
  static instance: BaseLayer;
  private LayerGroup = LayerGroup.getInstance();

  constructor() {
    super();
    if (!BaseLayer.instance) {
      BaseLayer.instance = this;
    }
    this.addToLayer();
  }
  addToLayer() {
    this.LayerGroup.addChild(this);
  }
  static getInstance(): BaseLayer {
    return BaseLayer.instance;
  }
}